module.exports = __webpack_public_path__ + "img/logobotRetina.76829649.png";